var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"accesibility",style:({ 
    '--sidebar-width': _vm.sidebarWidth,
    '--height': _vm.height
  }),on:{"click":_vm.handleChangeAccesibility}},[_c('center',{staticStyle:{"margin-top":"15px","color":"white"}},[_c('v-icon',{staticStyle:{"color":"white","font-size":"80px"}},[_vm._v("\n      mdi-wheelchair-accessibility\n    ")]),_c('br'),_c('span',{staticClass:"label"},[_vm._v(_vm._s(_vm.$t('totem.accessibility').toUpperCase()))])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }